import { defineStore } from 'pinia';
import { getSystemNameApi } from '@/api/login';
export const useSystemNameStore = defineStore('systemName', () => {
  const systemName = ref('');
  const tenantId = ref('');
  const getSystemName = computed(() => systemName.value);
  const setSystemName = name => {
    systemName.value = name;
    localStorage.setItem('asp-title', name);
    document.title = name;
  };
  // 获取当前租户的系统名称
  const getSystemNameByApi = async () => {
    if (!sessionStorage.getItem('token')) {
      console.error('获取系统名称失败：用户未登录');
      return;
    }
    try {
      const res = await getSystemNameApi();
      // 未设置系统名则更新为 window 配置
      setSystemName(res?.name || window._aspConfig?.title);
      tenantId.value = res?.tenantId;
    } catch (error) {
      console.error('获取系统名称失败：', error);
    }
  };
  // 更新系统名称回显
  const updateSystemName = async () => {
    const title = localStorage.getItem('asp-title') || window._aspConfig?.title;
    setSystemName(title);
  };
  return {
    tenantId,
    systemName,
    getSystemName,
    setSystemName,
    getSystemNameByApi,
    updateSystemName
  };
});